"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// scanner events
var Scanner = /*#__PURE__*/function () {
  function Scanner(callback) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Scanner);
    this.callback = callback;
    this.buffer = ''; // current scanner input
    this.lastTime = 0; // last scan time
    this.timeInterval = options.timeInterval || 100;
    this.minLength = options.minLength || 3;
    this.preventInput = options.preventInput || false;
    this.isScanning = false;

    // 当前聚焦元素（扫码开始前）
    this.activeEl = null;
    this.activeElStartValue = '';
    this.handler = this.keydown.bind(this);
  }
  return _createClass(Scanner, [{
    key: "start",
    value: function start() {
      console.log('listener start');
      window.addEventListener('keydown', this.handler, true);
    }
  }, {
    key: "stop",
    value: function stop() {
      console.log('listener remove');
      window.removeEventListener('keydown', this.handler, true);
      this.reset();
    }
  }, {
    key: "reset",
    value: function reset() {
      this.buffer = '';
      this.isScanning = false;
      this.activeEl = null;
      this.activeElStartValue = '';
      this.lastTime = 0;
    }
  }, {
    key: "isEditableElement",
    value: function isEditableElement(el) {
      if (!el) return false;
      var tag = el.tagName;
      return tag === 'INPUT' || tag === 'TEXTAREA' || el.isContentEditable === true;
    }
  }, {
    key: "rollbackActiveInput",
    value: function rollbackActiveInput() {
      if (!this.activeEl || !this.isEditableElement(this.activeEl)) return;
      if ('value' in this.activeEl) {
        this.activeEl.value = this.activeElStartValue;
        this.activeEl.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      } else if (this.activeEl.isContentEditable) {
        this.activeEl.textContent = this.activeElStartValue;
        this.activeEl.dispatchEvent(new Event('input', {
          bubbles: true
        }));
      }
      if (typeof this.activeEl.blur === 'function') {
        this.activeEl.blur();
      }
    }
  }, {
    key: "keydown",
    value: function keydown(e) {
      var now = Date.now();

      // 超时重置
      if (now - this.lastTime > this.timeInterval) {
        this.buffer = '';
        this.isScanning = false;
        this.activeEl = null;
        this.activeElStartValue = '';
      }
      this.lastTime = now;
      var isChar = e.key.length === 1;
      var isEnter = e.key === 'Enter';
      if (!isChar && !isEnter) return;
      var currentActive = document.activeElement;

      // 开始记录扫码前焦点
      if (!this.buffer && isChar) {
        this.activeEl = currentActive;
        if (this.isEditableElement(currentActive)) {
          this.activeElStartValue = 'value' in currentActive ? currentActive.value || '' : currentActive.textContent || '';
        } else {
          this.activeElStartValue = '';
        }
      }

      // 回车结束扫码
      if (isEnter) {
        if (this.isScanning && this.preventInput) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (this.buffer) {
          this.callback(this.buffer);
        }
        this.reset();
        return;
      }

      // 收字符
      if (isChar) {
        this.buffer += e.key;
      }

      // 达到长度，认定扫码枪
      if (!this.isScanning && this.buffer.length >= this.minLength) {
        this.isScanning = true;
        if (this.preventInput) {
          // 回滚已经误进 input 的字符
          this.rollbackActiveInput();
        }
      }

      // 扫码状态阻止继续写入 input
      if (this.isScanning && this.preventInput) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }]);
}();
var _default = exports.default = Scanner;